import React from 'react'
import "./assets/js/main";
import About from './components/About'
import Contact from './components/Contact';
import Facts from './components/Facts'
import Footer from './components/Footer';
import Hero from './components/Hero'
import Protfolio from './components/Protfolio'
import Resume from './components/Resume';
import Services from './components/Services';
import Skills from './components/Skills'
import Testimonials from './components/Testimonials';

const Home = () => {
  return (
    <div>
        <Hero/>
        <About/>
        <Facts/>
        <Skills/>
      <Resume/>
        <Protfolio/>
        <Services/>
        <Testimonials/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default Home